import styled from "styled-components";

import { SPACING } from "../../utils/constants";

export const Track = styled.div<{ $height: number; $trackColor: string }>`
  position: relative;
  width: 100%;
  height: ${(props) => props.$height}px;
  border-radius: ${SPACING.xs}px;
  background: ${(props) => props.$trackColor};
  overflow: hidden;
`;

export const Fill = styled.div<{ $pct: number; $color: string }>`
  height: 100%;
  width: ${(props) => props.$pct}%;
  background: ${(props) => props.$color};
  border-radius: ${SPACING.xs}px;
`;
